import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import template from './textEdit.jsx';
import displayNames from '../displayNames';
import compose from '../../hoc/compose';
import withClickOutside from '../../hoc/withClickOutside';
import KEYS from '../../common/keyCodes';
var validate = function validate(validators, value) {
  var invalid = _.find(validators, function (_ref) {
    var validator = _ref.validator;
    return !validator(value);
  });
  return {
    isInvalid: invalid !== undefined,
    invalidMessage: invalid === null || invalid === void 0 ? void 0 : invalid.invalidMessage
  };
};
var TextEdit = /*#__PURE__*/function (_React$Component) {
  function TextEdit(props) {
    var _this;
    _classCallCheck(this, TextEdit);
    _this = _callSuper(this, TextEdit, [props]);
    var _validate = validate(props.validators, props.value),
      isInvalid = _validate.isInvalid,
      invalidMessage = _validate.invalidMessage;
    _this.state = {
      value: props.value,
      isInvalid: isInvalid,
      invalidMessage: invalidMessage
    };
    _this.onInputTextChange = function (newVal) {
      _this.setState(_objectSpread({
        value: newVal
      }, validate(props.validators, newVal)));
    };
    _this.isInvalid = function () {
      return _this.state.isInvalid;
    };
    _this.handleOnChange = function () {
      if (!_this.isInvalid()) {
        _this.applyChanges();
      }
    };
    _this.handleKeyDown = function (e) {
      if (_.includes([KEYS.ENTER, KEYS.ESC], e.keyCode)) {
        e.stopPropagation();
        e.preventDefault();
        if (e.keyCode === KEYS.ESC) {
          _this.props.cancel();
        } else {
          _this.handleOnChange();
        }
      }
    };
    _this.applyChanges = function () {
      return _this.props.onChange(_this.state.value);
    };
    return _this;
  }
  _inherits(TextEdit, _React$Component);
  return _createClass(TextEdit, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.onClickOutside(this.handleOnChange);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.keyboardShortcuts) {
        window.addEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.keyboardShortcuts) {
        window.removeEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
TextEdit.displayName = displayNames.SORT_BY_DRAG_LIST_TEXT_EDIT;
TextEdit.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  validators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),
  placeholder: PropTypes.string,
  shouldTranslateInvalidMessage: PropTypes.bool,
  autoFocus: PropTypes.bool,
  keyboardShortcuts: PropTypes.bool,
  buttonText: PropTypes.node
};
TextEdit.defaultProps = {
  autoFocus: false,
  shouldTranslateInvalidMessage: true,
  keyboardShortcuts: false
};
export default compose(TextEdit, [withClickOutside]);